import React, { memo, ReactElement, SyntheticEvent, useCallback, useState } from 'react';
import classes from './DatabaseAccordion.module.scss';
import { AccordionProps } from '@mui/material/Accordion';
import { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { AccordionDetailsProps } from '@mui/material/AccordionDetails';
import { ReactComponent as ChevronIcon } from '../../assets/chevronRightFilled.svg';
import { CircularProgress } from '@mui/material';
import cx from 'classnames';

export const DatabaseAccordion = memo(function DatabaseMemoAccordion(props: AccordionProps) {
  const {
    children: childrenProp,
    expanded,
    onChange,
    defaultExpanded,
    TransitionProps, // exclude from "rest"
    ...rest
  } = props;
  const [open, setOpen] = useState(expanded || defaultExpanded);
  const [title, ...children] = React.Children.toArray(childrenProp);

  const handleClickExpand = useCallback(
    (e: SyntheticEvent<Element, Event>) => {
      setOpen((open) => {
        onChange(e, !open);
        return !open;
      });
    },
    [onChange],
  );

  return (
    <div
      {...rest}
      className={cx(classes.accordion, {
        [classes.accordion_expanded]: expanded,
      })}
    >
      {React.cloneElement(title as ReactElement, { handleClickExpand })}
      {open ? children : null}
    </div>
  );
});

export const DatabaseTitle = memo(function DatabaseMemoTitle(
  props: AccordionSummaryProps & {
    loading?: boolean;
    isStream?: boolean;
    handleClickExpand?: () => void;
  },
) {
  const { loading, isStream, children, handleClickExpand } = props;
  const Icon = <ChevronIcon />;

  return (
    <div className={cx(classes.title, props.className)} onClick={handleClickExpand}>
      {isStream ? null : (
        <div className={classes.expandIcon}>
          {loading ? <CircularProgress size="16px" /> : Icon}
        </div>
      )}
      {children}
    </div>
  );
});

export const DatabaseDetails = memo(function DatabaseMemoDetails(props: AccordionDetailsProps) {
  const { children } = props;
  return <div className={classes.details}>{children}</div>;
});
